import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExerciseHeaderComponent } from './exercise-header/exercise-header.component';
import { RouterOutlet, Router } from '@angular/router';
import { NgZone }  from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from './message.service';
import { RouterModule, Routes } from '@angular/router';
import { QuestionHeaderComponent } from './question-header/question-header.component';
import { ShowExampleComponent } from './show-example/show-example.component';
import { LargerDirective } from './larger2.directive';
import { SmallerDirective } from './smaller.directive';
import { GraphModule } from './graph/graph.module';

@NgModule({
  imports: [
    CommonModule,
    NgbModule, 
    RouterModule
  ],
  declarations: [ExerciseHeaderComponent, QuestionHeaderComponent, ShowExampleComponent, LargerDirective, SmallerDirective], 
  exports: [ExerciseHeaderComponent, QuestionHeaderComponent, ShowExampleComponent, LargerDirective, SmallerDirective, GraphModule], 
  providers: [MessageService]
})
export class SharedModule { }
